import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { fetchCalculations, deleteCalculator, showCal } from './../../../actions/addTreatments';
import NewOralSuspensionForm from './NewOralSuspension';
// import NewDosageForm from './newDosage';
import NewTabletForm from './newTablet';
import ViewDosageCalc from './viewCalc';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Loader } from '../../../components/loader';

import { BreadCrumb } from '../../../components/breadcrumb';

const $ = window.$;
const ctOptions = {
    0: 'Formula',
    1: 'Dosage',
    2: 'Tablet'
}


const { SearchBar } = Search;

class Calculators extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      contentData: [],
      calcId: '',
      calcType: '',
      deleteCId: '',
    }

}

tableHeaderColumnData = [
    {
        dataField: 'actions', text: 'Actions', formatter: this.buttonFormatter.bind(this)
    },
    {
        dataField: 'id', text: 'Id', sort: true
    },
    {
        dataField: 'treatmentName', text: 'Calculator Name', sort: true
    },
    {
        dataField: 'calculationType', text: 'Type', sort: true, formatter: cell => cell,
        filterValue: (cell, row) => {
            for(let t in ctOptions){
            if(ctOptions[t]===cell){
                return t;
          }
        }
      }
    },

];

buttonFormatter(cell, row) {
    return (
      <div>
        <a href="#" onClick={() => this.openViewModal(row.id, row.calculationType)} className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="View">
            <i className="far fa-eye"></i>
        </a>
        <span className="dropdown show">
            <span className="dropdown">
              <a href="" className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
                <i className="la la-ellipsis-h"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <a className="dropdown-item" onClick={ () => this.openConfirmModal(row.id) }>
                  <i className="la la-trash-o"></i> Delete
                </a>
              </div>
            </span>
        </span>
      </div>
    );
}

openViewModal(cId, cType) {
    this.setState({calcId: cId, calcType: cType})
    this.props.showCal(cId);
    $('#view_formula').modal('show');
}

openConfirmModal(cId) {
    this.setState({deleteCId: cId})
    $('#confirm_delete_modal').modal('show');
}

deleteCalculator(){
    this.setState({ loading: true });
    
    if(this.state.deleteCId)
        this.props.deleteCalculator(this.state.deleteCId);
    else {
        NotificationManager.warning('Invalid calculator.');
        this.setState({ loading: false });
    }
}

componentDidMount() {
    this.props.fetchCalculations();
}

componentWillReceiveProps = (nextProps) => {
    if (nextProps.data.addFormulaReducer.setCalculations !== this.props.data.addFormulaReducer.setCalculations) {
      this.props.fetchCalculations();
      NotificationManager.success("Calculator created successfully");
    }
    if (nextProps.data.addFormulaReducer.setCalculationsError !== this.props.data.addFormulaReducer.setCalculationsError) {        
        NotificationManager.error("Failed to create Calculator");
    }
    if (nextProps.data.addFormulaReducer.calculations !== this.props.data.addFormulaReducer.calculations) {
      this.setState({ contentData: nextProps.data.addFormulaReducer.calculations });
    }

    if (nextProps.data.addFormulaReducer.calculatorsToDelete !== this.props.data.addFormulaReducer.calculatorsToDelete) {
        this.setState({loading: false});
        this.props.fetchCalculations();
        NotificationManager.success("Calculator Deleted Successfully");
        $('#confirm_delete_modal').modal('hide');
    }
    if (nextProps.data.addFormulaReducer.calculatorsToDeleteError !== this.props.data.addFormulaReducer.calculatorsToDeleteError) {
        this.setState({loading: false});
        NotificationManager.error("Failed to delete Calculator");
        $('#confirm_delete_modal').modal('hide');
    }
}

items = [
    {title: 'Treatment', to: '/treatments'},
    {title: 'Treatment Calculator', to: '/calculators'}
]

render() {
    const { contentData } = this.state;

    return (
        <div className="m-grid m-grid--hor m-grid--root m-page">
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
                <BreadCrumb items={this.items}/>
                <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                    <div className="m-grid__item m-grid__item--fluid m-wrapper">
                        <div className="m-portlet m-portlet--mobile">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <h3 className="m-portlet__head-text">Medicating Calculators                                         
                                        </h3>
                                    </div>
                                </div>
                                <div className="m-portlet__head-tools">
                                    <ul className="m-portlet__nav">
                                        <li className="m-portlet__nav-item ">
                                            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air mx-2" data-toggle="modal" data-dismiss="modal" data-target="#new_oral_suspension"  >
                                                <span><i className="fas fa-syringe fa-3x"></i><span className="hide_in_mobile">Set Oral Suspension</span></span>
                                            </a>
                                        </li>
                                        
                                        <li className="m-portlet__nav-item ">
                                            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air mx-2"  data-toggle="modal" data-dismiss="modal" data-target="#new_tablet" >
                                                <span ><i className="fas fa-pills fa-3x"></i><span className="hide_in_mobile">Set Tablet</span></span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="m-portlet__body">
                                <NewOralSuspensionForm />
                                {/* <NewDosageForm /> */}
                                <NewTabletForm />
                                <ViewDosageCalc calcId={this.state.calcId} calcType={this.state.calcType} />

                                <ToolkitProvider

                                    keyField="id"
                                    data={contentData}
                                    columns={this.tableHeaderColumnData}
                                    search
                                    defaultSortDirection="asc"
                                    hover={true}
                                    
                                    filter={filterFactory()}
                                >
                                    {
                                        props => (
                                            <div>
                                                <div className='px-0 mb-4 search-bar'>
                                                <div className='col-lg-3 px-0 inner-addon right-addon'>
                                                <i className="fas fa-search"></i>
                                                <SearchBar {...props.searchProps} />
                                                </div>
                                                </div>
                                                <BootstrapTable
                                                    classes="petTable"
                                                    {...props.baseProps}
                                                    pagination={paginationFactory()}
                                                />
                                            </div>
                                        )
                                    }
                                </ToolkitProvider>
                                {/* <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={contentData} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } /> */}
                                
                            </div>
                        </div>

                        <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLabel">Confirm to delete</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to delete this Calculator?</p>
                                    </div>
                                    <div className="modal-footer">
                                        {this.state.loading == false ?
                                            <div>
                                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                                <button type="button" onClick={() => this.deleteCalculator()} className="btn btn-primary m-btn--pill">Confirm</button>
                                            </div>
                                            :
                                            <div className="center-row">
                                                <Loader size={50} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>                       
                    </div>
                </div>
            </div>
        </div>

    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  data: state
});

const mapDispatchToProps = dispatch => ({
  
    fetchCalculations: () => {
        dispatch(fetchCalculations());
    },
    deleteCalculator: (id) => {
        dispatch(deleteCalculator(id));
    },
    showCal: (id) => {
        dispatch(showCal(id));
    },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Calculators));
